"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  commonFetch: () => commonFetch,
  dataURItoFile: () => dataURItoFile,
  downloadDocument: () => downloadDocument,
  formatDateInput: () => formatDateInput,
  formatDateToOrdinal: () => formatDateToOrdinal,
  formatPhoneNumber: () => formatPhoneNumber,
  formatThaiId: () => formatThaiId,
  getAgeByBirthday: () => getAgeByBirthday,
  getBornDateRangeByAge: () => getBornDateRangeByAge,
  getBornYearByAge: () => getBornYearByAge,
  insertInterval: () => insertInterval,
  isLandLine: () => isLandLine,
  isObjectEmpty: () => isObjectEmpty,
  jsonToBase64: () => jsonToBase64,
  matchParamsAndLink: () => matchParamsAndLink,
  mockUseFlags: () => mockUseFlags,
  moneyToNumber: () => moneyToNumber,
  motorPolicyHolderNameValidator: () => nameValidator,
  numberToMoney: () => numberToMoney,
  rabbitString: () => rabbitString,
  removeZeroPadding: () => removeZeroPadding,
  uploadDocumentViaDocumentService: () => uploadDocumentViaDocumentService,
  validateMotorPolicyHolderName: () => validateMotorPolicyHolderName
});
module.exports = __toCommonJS(src_exports);

// src/array.ts
var insertInterval = (array, interval, item) => {
  const newArray = array.slice();
  const step = interval + 1;
  let pos = interval;
  while (pos < newArray.length) {
    newArray.splice(pos, 0, item);
    pos += step;
  }
  return newArray;
};
var isObjectEmpty = (obj) => Object.keys(obj).length === 0;

// src/formatter/money.ts
var numberToMoney = (amount, locale = "th-TH") => {
  const formatter = new Intl.NumberFormat(locale);
  return formatter.format(amount);
};
var moneyToNumber = (moneyString) => parseInt(moneyString.replace(/,/g, ""), 10);

// src/formatter/number.ts
var removeZeroPadding = (value) => value.replace(/^0+(?!\.|$)/, "");

// src/apifetch/commonFetch.ts
var commonFetch = async (url, option) => fetch(url, option).then((r) => {
  if (r.ok) {
    return r.json();
  }
  throw Error("api error");
});

// src/formatter/jsonToBase64.ts
var jsonToBase64 = (obj) => {
  const objJsonStr = JSON.stringify(obj);
  const objJsonB64 = Buffer.from(objJsonStr).toString("base64");
  return objJsonB64;
};

// src/formatter/dataURItoFile.ts
var dataURItoFile = async (dataURL) => {
  const response = await fetch(dataURL);
  const blob = await response.blob();
  return new File([blob], "fileName.jpg", {
    type: "image/png",
    lastModified: (/* @__PURE__ */ new Date()).getTime()
  });
};

// src/formatter/date.ts
var import_date_fns = require("date-fns");
var formatDateToOrdinal = (date) => (0, import_date_fns.format)(new Date(date), "do MMMM yyyy");
var getMaxDaysByMonthDigits = (month) => {
  const thirtyDays = [4, 6, 9, 11];
  let maxDays = 31;
  if (thirtyDays.includes(month)) {
    maxDays = 30;
  } else if (month === 2) {
    maxDays = 29;
  }
  return maxDays;
};
var getValidDate = (days, value) => {
  const month = parseInt(value.substring(2, 4), 10);
  const year = parseInt(value.substring(4, 8), 10);
  let maxDays = getMaxDaysByMonthDigits(month);
  let validDays = days;
  if (!Number.isNaN(month) && !Number.isNaN(year) && year > 999) {
    maxDays = (0, import_date_fns.getDaysInMonth)(new Date(year, month - 1));
  }
  const prefix = days.slice(0, 1);
  if (days === "00") {
    validDays = "01";
  } else if (parseInt(prefix, 10) > 3 && days.length === 1) {
    validDays = `0${days}`;
  } else if (parseInt(days, 10) > maxDays) {
    validDays = maxDays.toString();
  }
  return validDays;
};
var getValidMonth = (month) => {
  const prefix = month.slice(0, 1);
  let validMonth = month;
  if (month === "00") {
    validMonth = "01";
  } else if (parseInt(prefix, 10) > 1) {
    validMonth = `0${month}`;
  } else if (parseInt(month, 10) > 12) {
    validMonth = "12";
  }
  return validMonth;
};
var formatDateInput = (value) => {
  const numericValue = value.replace(/\D/g, "");
  const parts = [];
  if (numericValue.length > 0) {
    parts.push(getValidDate(numericValue.substring(0, 2), numericValue));
  }
  if (numericValue.length > 2) {
    parts.push(getValidMonth(numericValue.substring(2, 4)));
  }
  if (numericValue.length > 4) {
    parts.push(numericValue.substring(4, 8));
  }
  return parts.join("/").slice(0, 10);
};

// src/apifetch/uploadDocument.ts
var import_ajax = require("rxjs/ajax");
var uploadDocumentViaDocumentService = async (uploadUrl, file, sizeLimit = 5242880 /* MEDIUM */) => {
  const gcHeader = {
    "x-goog-content-length-range": `0,${sizeLimit}`,
    "Content-Type": `${file.type}`
  };
  return new Promise((resolve, reject) => {
    (0, import_ajax.ajax)({
      method: "PUT",
      responseType: "blob",
      headers: gcHeader,
      crossDomain: true,
      url: uploadUrl,
      body: file
    }).subscribe({
      next: (value) => resolve(value),
      error: (err) => reject(new Error(err))
    });
  });
};

// src/downloadDocument/index.ts
var downloadDocument = async (documentPath) => {
  const downloadLink = `${documentPath}:file?download=true`;
  const { url } = await commonFetch(downloadLink);
  if (url) {
    window.location.assign(url);
  }
};

// src/validator/string.ts
var import_yup = require("yup");
var nameValidator = (0, import_yup.string)().required().max(40).test(
  "invalid",
  "invalid",
  (value) => Boolean(value.match(/^[A-Za-z\u0E00-\u0E7F .]+$/g))
);
var validateMotorPolicyHolderName = (value) => {
  try {
    nameValidator.validateSync(value);
    return {
      isValid: true,
      errorCode: ""
    };
  } catch (e) {
    const { type, params } = e;
    return {
      isValid: false,
      errorCode: type,
      params
    };
  }
};
var CustomString = class extends import_yup.StringSchema {
  customerName(trans = {}) {
    const { required, max, invalid } = {
      required: "Cannot be empty",
      max: "Maximum charater limit exceed",
      invalid: "Invalid charater present",
      ...trans
    };
    return this.required(required).max(40, max).test(
      "invalid",
      invalid,
      (value) => Boolean(value.match(/^[A-Za-z\u0E00-\u0E7F .]+$/g))
    );
  }
  check(value) {
    try {
      this.validateSync(value);
      return {
        isValid: true,
        errorCode: null,
        message: null
      };
    } catch (e) {
      const { type, errors } = e;
      return {
        isValid: false,
        errorCode: type,
        message: errors[0]
      };
    }
  }
};
var rabbitString = () => new CustomString();

// src/mockUseFlag/index.ts
var getFlagValue = (flag) => {
  const flagObject = typeof flag === "object";
  return {
    name: flagObject ? flag.name : flag,
    enabled: flagObject ? flag.enabled : true
  };
};
var getFlagObject = (flags, initialFlags = void 0) => {
  const result = initialFlags ?? {};
  flags?.forEach((flag) => {
    const flagVal = getFlagValue(flag);
    result[flagVal.name] = {
      enabled: flagVal.enabled ?? true
    };
  });
  return result;
};
var mockUseFlags = (flagsmith, flagsmithCore, flags) => {
  jest.spyOn(flagsmith, "useFlags").mockImplementation((keys) => {
    const initialFlags = keys.reduce(
      (o, flag) => ({ ...o, [flag]: { enabled: false } }),
      {}
    );
    return getFlagObject(flags ?? [], initialFlags);
  });
  jest.spyOn(flagsmithCore, "getAllFlags").mockReturnValue(getFlagObject(flags ?? []));
};

// src/helpers/matchParamsAndLink.ts
var matchParamsAndLink = (useQueryParams, baseUrl, queryParams) => {
  if (!useQueryParams || !queryParams || Object.keys(queryParams).length === 0) {
    return baseUrl;
  }
  const utmQuery = {};
  const randomRccidString = `rccid=${Math.random().toString(36).substring(2, 11)}`;
  Object.entries(queryParams).forEach(([key, value]) => {
    if (key !== "slug") {
      utmQuery[key] = value;
    }
  });
  if (Object.keys(utmQuery).length === 0) {
    const { origin, pathname, search } = new URL(baseUrl);
    const separator = search ? "&" : "?";
    return `${origin}${pathname}${search}${separator}${randomRccidString}`;
  }
  const buttonURLObj = new URL(baseUrl);
  const params = new URLSearchParams(buttonURLObj.search);
  const paramsObj = {};
  params.forEach((value, key) => {
    paramsObj[key] = value;
  });
  const mergeQuery = { ...paramsObj, ...utmQuery };
  const mergeQueryString = Object.entries(mergeQuery).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  ).join("&");
  buttonURLObj.search = mergeQueryString.concat(`&${randomRccidString}`);
  return buttonURLObj.toString();
};

// src/dateFunc/index.ts
var getAgeByBirthday = (date) => {
  const today = /* @__PURE__ */ new Date();
  const birthDate = new Date(date);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
    age -= 1;
  }
  return age;
};
var getBornYearByAge = (age) => {
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  return currentYear - age;
};
var getBornDateRangeByAge = (age) => {
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const minYear = currentYear - age;
  return {
    startDate: /* @__PURE__ */ new Date(`${minYear}-01-01`),
    endDate: /* @__PURE__ */ new Date(`${minYear}-12-31`)
  };
};

// src/formatter/phone.ts
var isLandLine = (value, rule) => {
  if (!value || ["phonevi", "phonesg"].includes(rule)) {
    return false;
  }
  const landLinePrefix = ["02", "03", "04", "05", "07"];
  return landLinePrefix.some((prefix) => value.startsWith(prefix));
};
var commonFormatter = (country, value, isLandline = false) => {
  if (!value) return "";
  const len = value.length;
  const patterns = {
    TH: isLandline ? len <= 5 ? [/^(\d{2})(\d{1,3})/, "$1-$2"] : [/^(\d{2})(\d{3})(\d{1,4})/, "$1-$2-$3"] : len <= 6 ? [/^(\d{3})(\d{1,3})/, "$1-$2"] : [/^(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3"],
    VN: /^84/.test(value) ? [/^(\d{2})(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3-$4"] : len <= 7 ? [/^(\d{4})(\d{1,3})/, "$1-$2"] : [/^(\d{4})(\d{3})(\d{1,3})/, "$1-$2-$3"],
    SG: /^65/.test(value) ? [/^(\d{2})(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3-$4"] : [/^(\d{4})(\d{1,4})/, "$1-$2"]
  };
  const [regex, format2] = patterns[country];
  return value.replace(regex, format2);
};
var formatPhoneNumber = (value, rule) => {
  if (!value) {
    return "";
  }
  switch (rule) {
    case "phonevi":
      return commonFormatter("VN", value);
    case "phonesg":
      return commonFormatter("SG", value);
    default:
      return commonFormatter("TH", value, isLandLine(value));
  }
};

// src/formatter/thaiId.ts
var formatThaiId = (value) => {
  if (!value) {
    return "";
  }
  const regex = /^(\d{1})(\d{0,4})(\d{0,5})(\d{0,2})(\d{0,1})/;
  const match = value.match(regex);
  if (!match) return value;
  return [match[1], match[2], match[3], match[4], match[5]].filter(Boolean).join("-");
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  commonFetch,
  dataURItoFile,
  downloadDocument,
  formatDateInput,
  formatDateToOrdinal,
  formatPhoneNumber,
  formatThaiId,
  getAgeByBirthday,
  getBornDateRangeByAge,
  getBornYearByAge,
  insertInterval,
  isLandLine,
  isObjectEmpty,
  jsonToBase64,
  matchParamsAndLink,
  mockUseFlags,
  moneyToNumber,
  motorPolicyHolderNameValidator,
  numberToMoney,
  rabbitString,
  removeZeroPadding,
  uploadDocumentViaDocumentService,
  validateMotorPolicyHolderName
});
//# sourceMappingURL=index.js.map